<template>
    <div class="safety-data-item">
        <div class="safety-data-item-type">
            <figure :class="datasheet.type">
                <span class="inline-svg">
                    <component :is="datasheet.type" />
                </span>
            </figure>
        </div>
        <div class="safety-data-item-content">
            <ul>
                <li>
                    <span>{{ datasheet.type }}</span>
                </li>
                <li>{{ datasheet.category }}</li>
            </ul>

            <h5 class="text-cod-gray">{{ datasheet.name }}</h5>
            <time>{{ datasheet.date | dateFormat('Do MMMM YYYY') }}</time>
        </div>

        <a :href="datasheet.file" class="btn safety-data-item-link circle-link" target="_blank" aria-label="Download file" download>
            <span>Download File</span>
            <button class="btn btn-circle text-blue-stone">
                <div class="relative">
                    <circle-button />
                    <figure>
                        <span class="inline-svg" style="padding-top: 100%">
                            <button-arrow />
                        </span>
                    </figure>
                </div>
            </button>
        </a>
    </div>
</template>
<script>
import buttonMixin from '../../mixins/buttonMixin'
const dayjs = require('dayjs')
const advancedFormat = require('dayjs/plugin/advancedFormat')

export default {
    mixins: [buttonMixin],
    created() {
        dayjs.extend(advancedFormat)
    },
    props: {
        datasheet: {
            type: Object,
            required: true,
        },
    },
    filters: {
        dateFormat(date, format) {
            return dayjs(date).format(format)
        },
    },
}
</script>
